import { Factory } from 'rosie';

Factory.define('AnswerPanel').attr('name', 'ANSWER_PANEL');

Factory.define('AnswerPanelWithDefaults')
  .extend('AnswerPanel')
  .attr('selectedAnswer', null)
  .attr('history', []);
